//var url_send = "https://ushopotp.herokuapp.com/pro/";
var url_send = "https://horlicks-healthometer.enscommerce.in/php/";
var site_url = "https://healthometer.horlicks.in";
var body_class = $("body").attr("class");

$(document).ready(function () {
  $(".back_mobile_from").click(function (event) {
    $(".div_mobile_number_otp").hide();
    $(".div_mobile_number_value").show();
  });
  function createCookie(id) {
    const d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie =
      "UnileverId=" + id["UnileverId"] + ";" + expires + ";path=/";
  }
  function gigya_register(mobile) {
    //gigyaV3 ushop
    console.log(
      JSON.stringify({
        profile: {
          header: {
            isoLanguage: "EN",
            isoCountry: "IN",
            brandCode: "BHA353",
            campaignId: "PN002119",
            campaignDescription: "Always On",
            origin: "https://www.theushop.in/",
            formType: "signUp",
            entity: "PRM2.6",
          },
          contactDetail: { mobileNumber: mobile },
          optInStatus: {
            legalAgeConsent: true,
            unileverEmailConsent: true,
            unileverSMSConsent: true,
          },
        },
      }),
    );
    var settings = {
      url: "https://forms-sg.unileversolutions.com/v3",
      method: "POST",
      timeout: 0,
      headers: {
        "x-api-key": "04d87952-86d9-4879-98b7-3227d3759728",
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        profile: {
          header: {
            isoLanguage: "EN",
            isoCountry: "IN",
            brandCode: "BHA353",
            campaignId: "PN002119",
            campaignDescription: "Always On",
            origin: "https://www.theushop.in/",
            formType: "signUp",
            entity: "PRM2.6",
          },
          contactDetail: { mobileNumber: mobile },
          optInStatus: {
            legalAgeConsent: true,
            unileverEmailConsent: true,
            unileverSMSConsent: true,
          },
        },
      }),
    };

    $.ajax(settings)
      .done(function (response) {
        console.log(response);
        createCookie(response);
      })
      .fail(function (response) {
        console.log(response);
      });
  }
  function login_customer(cust_id, time_value) {
    console.log("login_customer===" + cust_id);
    var time_value_data = time_value;
    var mobile_number_value = $("#mobile_number_value").val();
    //  Moengage.track_event("login", {
    //   //"email":login_email
    //   "phone":mobile_number_value

    // });
    //     //Moengage.add_email(login_email);

    //     //Moengage.add_unique_user_id(cust_id);
    //Moengage.add_unique_user_id(mobile_number_value);
    //Moengage.add_mobile(mobile_number_value);
    $("#error_without_from_submit_mobile").hide();
    //window.location.href = site_url + time_value;
    var login_url = site_url + time_value;
    $.ajax({
      url: login_url,
      type: "get",
      async: false,
      success: function (data) {
        var error = $(data).find(".Alert--error").text();
        console.log("error");
        console.log(error);
        var redirect_after_login = localStorage.getItem("redirect_after_login");
        console.log(redirect_after_login);
        $("#healthometer_test").show();
        $(".container.otp.hel_conatiner.background").hide();
        if (error == "" && redirect_after_login == "1") {
          localStorage.setItem("setup", "1");
          //adobe_login()// adobe
          var key_value = $("#mobile_number_otp").val();
          if (cust_id == "") {
            after_login_add_no_cid(cust_id, key_value, time_value);
          } else {
            after_login_add(cust_id, key_value, time_value);
          }
          //window.location.href = "/checkout?step=contact_information";
          $("#healthometer_test").show();
        } else if (error == "" && redirect_after_login == "0") {
          //adobe_login()// adobe
          if (body_class.match("template-login")) {
            //window.location.href = "/account";
          } else {
            //window.location.href = "";
          }
          $("#healthometer_test").show();
        } else {
          $("#error_without_from_submit_mobile").text(error);
          $("#error_without_from_submit_mobile").show();
        }
      },
      error: function (jqXHR, exception) {},
    });
  }

  function after_login_add_no_cid(cust_id, key_value, time_value) {
    console.log(cust_id);
    var mobile_number_value = $("#mobile_number_value").val();
    var key = key_value;
    $(".div_mobile_number_value").hide();
    $(".div_mobile_number_otp").hide();
    $("#checkout_email_or_phone").val("+91" + mobile_number_value);
    $(".flag-selector__select").val("IN").change();
    $(".section--shipping-address").css("background-color", "#fff");
    $(".section--shipping-address").css("border-color", "#cccccc");
    $(".section--shipping-address :input").attr("disabled", false);
    $("#continue_button")
      .attr("disabled", false)
      .css("background-color", "#1306bf");
    $("#continue_button").show();
  }

  function after_login_add(cust_id, key_value, time_value) {
    console.log(cust_id);
    var mobile_number_value = $("#mobile_number_value").val();
    var key = key_value;
    var select_name_selectized = $(".selectize-input .item").attr("data-value");
    var customer_tags = "mobile_reg," + select_name_selectized;
    var get_data_url =
      url_send +
      "after_login_add.php?c=" +
      cust_id +
      "&m=" +
      mobile_number_value +
      "&t=" +
      customer_tags +
      "&k=" +
      key_value;
    console.log(get_data_url);
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var data = JSON.parse(atob(this.responseText));
        console.log(data);

        var f = data.f;
        var l = data.l;
        var a1 = data.a1;
        var a2 = data.a2;
        var c = data.c;
        var p = data.p;
        var co = data.co;
        var ph = data.ph;
        var p_code = data.p_code;
        var c_code = data.c_code;
        var c_name = data.c_name;

        sessionStorage.setItem("f", f);
        sessionStorage.setItem("l", l);
        sessionStorage.setItem("a1", a1);
        sessionStorage.setItem("a2", a2);
        sessionStorage.setItem("c", c);
        sessionStorage.setItem("p", p);
        sessionStorage.setItem("co", co);
        sessionStorage.setItem("ph", ph);
        sessionStorage.setItem("mo", mobile_number_value);
        sessionStorage.setItem("p_code", p_code);
        sessionStorage.setItem("c_code", c_code);
        sessionStorage.setItem("c_name", c_name);

        $(".div_mobile_number_value").hide();
        $(".div_mobile_number_otp").hide();

        $("#checkout_email_or_phone").val("+91" + mobile_number_value);

        $(".flag-selector__select").val("IN").change();

        $("#checkout_shipping_address_first_name").val(f);
        $("#checkout_shipping_address_last_name").val(l);
        $("#checkout_shipping_address_address1").val(a1);
        $("#checkout_shipping_address_city").val(c);
        $("#checkout_shipping_address_phone").val(ph);
        $("#checkout_shipping_address_phone").attr(
          "data-phone-formatter-country-code",
          "91",
        );
        //$("#checkout_shipping_address_province").val(p_code);

        $(".section--shipping-address").css("background-color", "#fff");
        $(".section--shipping-address").css("border-color", "#cccccc");

        $(".section--shipping-address :input").attr("disabled", false);
        $("#continue_button")
          .attr("disabled", false)
          .css("background-color", "#1306bf");
        $("#continue_button").show();

        //                     if(customer_id_update == undefined){
        //                       $(".verify_code").trigger("click");
        //                     }else{

        //                     }
      }
    };
    xhttp.open("POST", get_data_url, true);
    xhttp.send();
  }
  function registerUser(cust_id, key_value, time_value) {
    var mobile_number_value = $("#mobile_number_value").val();
    var gigya_mobile_number_value = "+91" + mobile_number_value;
    //gigya_register(gigya_mobile_number_value);//only for ushop now
    //adobe_register_start();

    var key = key_value;
    //var page_url = window.theme.canonical_url;
    var customer_tags = "";
    // if(page_url.match("pepsodent")){
    //   customer_tags = 'Dentist';
    // }else{
    var select_name_selectized = $(".selectize-input .item").attr("data-value");
    customer_tags = "mobile_reg," + select_name_selectized;
    //}

    var get_data_url =
      url_send +
      "verify_process.php?m=" +
      mobile_number_value +
      "&t=" +
      customer_tags +
      "&k=" +
      key_value;
    //console.log(get_data_url);
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      ////console.log(this.responseText);
      if (this.readyState == 4 && this.status == 200) {
        var data = JSON.parse(atob(this.responseText));
        ////console.log(data);

        //var customer_id_update = $(data).find("#c_uid").val();
        var customer_id_update = data.time;
        var time_value = data.date;
        //console.log("vvvvvv"+ customer_id_update);
        if (customer_id_update == undefined) {
          //console.log("*********again click**********");
          $(".verify_code").trigger("click");
        } else {
          // Moengage.track_event("register", {
          // "phone":mobile_number_value
          // });
          // Moengage.add_unique_user_id(mobile_number_value);
          // Moengage.add_mobile(mobile_number_value);
          // console.log("registerUser==="+cust_id);

          login_customer(cust_id, time_value);
          //adobe_register();
        }
      }
    };
    xhttp.open("POST", get_data_url, true);
    xhttp.send();
  }

  $(".send_code").click(function () {
    //alert("hhhh")
    var select_name_selectized = $(".selectize-input .item").attr("data-value");
    var camp = $("#select-camp").val();
    var drpcode = $("#drpcode").val();
    //console.log(drpcode,"kkkkkkkkkkkkkkkkkkkkkkk");
    localStorage.setItem("CapmLocation", camp);
    localStorage.setItem("drpcode", drpcode);

    drpcode = drpcode ? String(drpcode).trim() : "";
    $(".selectize-input.items.full.has-options.has-items").css(
      "color",
      "#001b63",
    );
    if (select_name_selectized == "ESE Team Member") {
      $(".selectize-input.items.full.has-options.has-items").css(
        "color",
        "red",
      );
    }
    if (camp == "") {
      $(".selectize-input.items.not-full.has-options").css("color", "red");
      return false;
    }
    if (typeof drpcode === "undefined") {
      $(".selectize-input.items.not-full.has-options").css("color", "red");
      return false;
    } else if (drpcode.length < 7 || drpcode.length > 8) {
      $(".selectize-input.items.not-full.has-options").css("color", "red");
      return false;
    }

    $(".suggestion").css("color", "#001871");
    var remember = document.getElementById("otp_consent");
    if (remember.checked) {
      var mobNumber = $("#mobile_number_value").val();
      localStorage.setItem("select_name_selectized", select_name_selectized);
      //  localStorage.setItem("CapmLocation",camp);
      if (mobNumber != "") {
        mobileVerification(mobNumber);
      }
    } else {
      $(".suggestion").css("color", "red");
    }
  });

  function mobileVerification(mobNumber) {
    //var mobUrl = "http://newpetsessentia.ens.enterprises/index.php?mobile_number="+mobNumber;
    var mobUrl = url_send + "send_otp_6.php?mobile_number=" + mobNumber;
    //var mobUrl = "https://horlicks-healhometer.herokuapp.com/send_otp_6.php?mobile_number="+mobNumber;
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        //countdown(61);
        timer(60);
        var json_data = JSON.parse(this.responseText);
        console.log(this.responseText);
        console.log("nooooooooo", json_data);
        console.log(this.responseText.split(" ")[0] + "2651446");
        console.log("send otp");
        if (json_data.status == "success") {
          $(".div_mobile_number_value").hide();
          //$(".mobile_numbers_otp").val(mobNumber);
          $(".div_mobile_number_otp").show();
        }
      }
    };
    xhttp.open("GET", mobUrl, true);
    xhttp.send();
  }

  $("#mobile_number_value").keyup(function (e) {
    var phoneNum = $(this).val();
    $("#checkout_email_or_phone").val(phoneNum);
    $("#checkout_email_or_phone").trigger("keyup");
    $(".field--email_or_phone input[type=hidden]").val("+91" + phoneNum);
    var phone_regex = /^[6789][0-9]{4}([ ]?)[0-9]{5}$/;
    //var phone_regex = /^$/;
    if (!phone_regex.test(phoneNum)) {
      $("#phone_error").show();
      $(".send_code").prop("disabled", true);
    } else {
      $("#phone_error").hide();
      $(".send_code").prop("disabled", false);
    }
  });
  $(".verify_code").click(function () {
    //$(".back_mobile_from").hide();
    //var mobNumber = $('.mobile_numbers_otp').val();
    var mobNumber = $("#mobile_number_value").val();
    var otpNumber = $("#mobile_number_otp").val();
    //        $('.digit-group input').each(function(){
    //          otpNumber += $(this).val();
    //        });
    //var mobotpUrl = "http://newpetsessentia.ens.enterprises/checkOtp.php?mobile_no="+mobNumber+"&otp_code="+otpNumber;
    var mobotpUrl =
      url_send +
      "check_otp.php?mobile_no=" +
      mobNumber +
      "&otp_code=" +
      otpNumber;

    ////console.log(mobotpUrl);
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var json_data = JSON.parse(this.responseText);
        ////console.log(json_data);
        var status = json_data.status;
        var otp_msg = json_data.msg;

        if (status == "success") {
          $(".verify_code").text("Verifying..");
          $(".back_mobile_from").hide();

          $(".otp_msg_failed").hide();
          //$(".otp_msg_success").show();
          $(".progress_img").show();
          var url_get_data =
            url_send +
            "customer_update.php?key=" +
            otpNumber +
            "&mobile=" +
            mobNumber +
            "&case=get_data";
          ////console.log(url_get_data);
          var xhttpp = new XMLHttpRequest();
          xhttpp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
              ////console.log(data1);
              //var customer_details =JSON.parse(JSON.stringify(data1));
              ////console.log(this.responseText);
              ////console.log(JSON.parse(this.responseText));
              var customer_details = JSON.parse(atob(this.responseText));
              ////console.log(customer_details);
              var cust_id = customer_details.time;

              //var cust_email = "";
              var cust_password = customer_details.flag;
              var time_value = customer_details.sec;
              //var cust_latest = customer_details.latest;
              //                       if(cust_latest == "0"){
              //                         time_value = $("#mobile_number_value").val();
              //                       }

              //                       if((cust_id == "" ) && (cust_password == "0" )){
              //                         registerUser(cust_id, otpNumber,time_value);
              //                       }else if((cust_id != "" ) && (cust_password == "0")){
              //                         //phone_number_update(cust_id , "",otpNumber);
              //                         //registerUser(cust_id, otpNumber,time_value);
              //                       }else if((cust_id != "" ) && (cust_password != "0")){
              //                         login_customer(cust_id,time_value);
              //                       }

              if (cust_id == "") {
                registerUser(cust_id, otpNumber, time_value);
              } else if (cust_id != "") {
                console.log("login_customer===" + cust_id);
                login_customer(cust_id, time_value);
              }
            }
          };
          xhttpp.open("GET", url_get_data, true);
          xhttpp.send();
          digitalData.eventList = [];
          var ev = {};
          ev.eventInfo = {
            type: ctConstants.trackEvent,
            eventAction: ctConstants.signIns,
            eventLabel: "Log in",
            eventValue: 1,
          };
          ev.category = { primaryCategory: ctConstants.other };
          ev.subcategory = "Lead";
          digitalData.event.push(ev);
        } else {
          $(".otp_msg_failed").show();
          //registration_error();
          //$(".otp_msg_success").hide();
          $(".progress_img").hide();
        }
      }
    };
    xhttp.open("GET", mobotpUrl, true);
    xhttp.send();
  });

  let countdown;
  function timer(seconds) {
    clearInterval(countdown);
    const now = Date.now();
    const then = now + 120 * 1000;
    displayTimeLeft(seconds);

    //displayEndTime(then);
    countdown = setInterval(() => {
      const secondsLeft = Math.round((then - Date.now()) / 1000);
      console.log(secondsLeft, "secondsLeft");
      if (secondsLeft < 0) {
        clearInterval(countdown);
        $(".resend_button_checkout").css("display", "block");
        $(".resend_button_reg").css("display", "block");
        $(".resend_otp_message").css("display", "none");
        $(".resend_button").css("display", "block");
        return;
      } else {
        $(".resend_button_checkout").css("display", "none");
        $(".resend_button_reg").css("display", "none");
        $(".resend_otp_message").css("display", "block");
        $(".resend_button").css("display", "none");
      }
      displayTimeLeft(secondsLeft);
    }, 1000);
  }

  function displayTimeLeft(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainderSeconds = seconds % 60;
    const display = `${minutes}:${remainderSeconds < 10 ? "0" : ""}${remainderSeconds}`;
    ``;
    console.log(display, "dis");
    //if(state == "login"){
    var counter = document.getElementById("resendcountdown");
    //}else{
    //	var counter = document.getElementById("resendcountdown_reg");
    //}
    counter.innerHTML = display;
  }

  $(".resend_button a").click(function () {
    var mobNumber = $("#mobile_number_value").val();
    mobileVerification(mobNumber);
    //$(".otp_msg").text('');
    //countdown(61);
    timer(120);
  });

  /*******************start extra code according to client requirement**********************/
  //setTimeout(()=>{$('.login-pop-up-mobile').show()},3000); // no need now

  //var page_url = window.theme.canonical_url;
  var ExistPincode = localStorage.getItem("ExistPincode");
  // if((page_url.match("pepsodent")) && (ExistPincode)) {
  //     setTimeout(()=>{$('.login-pop-up-mobile').show()},3000); // for pepsodent page
  //  }
  //localStorage.setItem('redirect_after_login', "0");
  $(".icon-popup-close .bx-close-xsvg").click(function () {
    $(this).closest(".login-pop-up-mobile").hide();
  });

  if (window.theme.isCustomer) {
    //console.log("********************mohi1**************************");
    //console.log(localStorage.getItem('close_update_popup'));

    if (localStorage.getItem("close_update_popup") != "1") {
      //setTimeout(()=>{$('.customer_update_account_popup').show()},3000); // onload profile update popup will show aftr login
    }
    $(".update_details").click(function () {
      //$('.customer_update_account_popup').show();
    });
    $(".customer_update_account_popup-close .bx-close-xsvg").click(function () {
      localStorage.setItem("close_update_popup", "1");
      $(this).closest(".customer_update_account_popup").hide();
    });
  }

  if (body_class) {
    if (body_class.match("template-login")) {
      console.log("*****template-login******");
      if (window.theme.isCustomer) {
      } else {
        localStorage.setItem("redirect_after_login", "0");
        $(".login-pop-up-mobile").show();
        $("body").addClass("popup-acc");
        $(".popup-blur").addClass("popup-blur-mobile");
        setTimeout(() => {
          $(".login-pop-up-mobile").addClass("popup-active");
        }, 80);
      }
    }
  }
  $(".location-icon +.Header__Icon,.mob_login_customer").click(
    function (event) {
      console.log("click mohit");
      ////console.log(window.theme.isCustomer)
      if (window.theme.isCustomer) {
      } else {
        event.preventDefault();
        localStorage.setItem("redirect_after_login", "0");
        $(".login-pop-up-mobile").show();
        $("body").addClass("popup-acc");
        $(".popup-blur").addClass("popup-blur-mobile");
        setTimeout(() => {
          $(".login-pop-up-mobile").addClass("popup-active");
        }, 80);
      }
    },
  );

  if ($(window).width() <= 640) {
    $(".pop-send").click(function () {
      $(".banner-img").hide();
      $(".login-pop-up-mobile h1").css("margin-top", "-5%");
    });
    $(".back_mobile_from").click(function () {
      $(".banner-img").show();
    });
  }
  $(".icon-popup-close").click(function () {
    $(".popup-blur").removeClass("popup-blur-mobile");
    $("body").removeClass("popup-acc");
  });
  $(".linklist-pop").click(function () {
    $(".login-pop-up-mobile").show();
    $("body").addClass("popup-acc");
    $(".popup-blur").addClass("popup-blur-mobile");
    setTimeout(() => {
      $(".login-pop-up-mobile").addClass("popup-active");
    }, 80);
  });
  $("body").delegate(
    ".login-pop-up-mobile .step__footer__continue-btn",
    "click",
    function () {
      localStorage.setItem("redirect_after_login", "1");
    },
  );
  $("body").delegate(".openlogin span", "click", function () {
    //     localStorage.setItem('redirect_after_login', "1");
    //     $(".Drawer__Close.Icon-Wrapper--clickable").trigger('click');
    //     $('.login-pop-up-mobile').show();
    //     $('body').addClass('popup-acc');
    //   $('.popup-blur').addClass('popup-blur-mobile');
    //   setTimeout(()=>{$('.login-pop-up-mobile').addClass('popup-active')},80);
    $(".loaderChekout").show();
    $(".loaderChekout-overlay").show();
    var ExistLocation_form = localStorage.getItem("currentLocationId");
    cartUpdateWhilePincodeUpdate(ExistLocation_form, false);
    onCheckoutMonthlyReview();
  });

  $("body").delegate(".openlogin_redirect span", "click", function () {
    //   localStorage.setItem('redirect_after_login', "1");
    //   $(".Drawer__Close.Icon-Wrapper--clickable").trigger('click');
    //   $('.login-pop-up-mobile').show();
    $(".loaderChekout").show();
    $(".loaderChekout-overlay").show();
    var ExistLocation_form = localStorage.getItem("currentLocationId");
    cartUpdateWhilePincodeUpdate(ExistLocation_form, false);
    onCheckoutMonthlyReview();
    //window.location.href = "/checkout?step=contact_information";
  });

  function onCheckoutMonthlyReview() {
    var array_over_gift = [];
    //console.log("obj_monthly");
    //console.log(obj_monthly);
    $.ajax({
      url: "/cart.json",
      type: "get",
      async: false,
      success: function (result1) {
        result1.items.forEach(function (item) {
          var ItemId = item.id;
          if (obj_monthly.hasOwnProperty(ItemId)) {
            var monthly_item_purchsed = obj_monthly[ItemId];
            var limit_monthly_item = 10;
            var cart_monthly_value = $(".monthly_" + ItemId).val();
            var total_monthly_cart_and_order =
              parseInt(monthly_item_purchsed) + parseInt(cart_monthly_value);
            //console.log(total_monthly_cart_and_order)
            if (total_monthly_cart_and_order >= limit_monthly_item) {
              array_over_gift.push(ItemId);
            }
          }
        });

        //console.log(array_over_gift);
        //console.log(array_over_gift.length);
        if (array_over_gift.length > 0) {
          //console.log("Monthly above item");
          for (let i = 0; i < array_over_gift.length; i++) {
            var id_free = array_over_gift[i];
            //console.log(id_free);
            $.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: { id: id_free, quantity: 0 },
              dataType: "json",
              async: false,
              success: function (data) {
                //console.log(i);
                //console.log(array_over_gift.length);
                var redirect_free = array_over_gift.length - 1;
                //console.log(redirect_free);
                if (redirect_free == i) {
                  window.location.href = "/checkout?step=contact_information";
                }
              },
              error: function () {
                //alert('error');
              },
            });
          }
        } else {
          window.location.href = "/checkout?step=contact_information";
        }
      },
      error: function () {},
    });
  }
  //   Mobile Sidebar Account / Login
  $("body").delegate(".mob_login span", "click", function (event) {
    //     //console.log(window.theme.isCustomer)
    if (window.theme.isCustomer) {
    } else {
      event.preventDefault();
      localStorage.setItem("redirect_after_login", "0");
      $(".Drawer__Close.Icon-Wrapper--clickable").trigger("click");
      $(".login-pop-up-mobile").show();
    }
  });

  /*******************end extra code according to client requirement**********************/
});
